const route = {
	path: 'accounting-rules-ats/new',
	name: 'accounting-rules-ats-new',
	meta: {
		title: 'Nueva Regla Ats',
	},
	component: () => import('@/pages/atsRules/ats-rules-new'),
};

export default route;



// WEBPACK FOOTER //
// ./src/router/ats-rules-new.js